/**
 * Globo Product Options (GPO) targets Prestige theme price selectors and overwrites
 * sale/compare-at with native Shopify variant.price + compare_at_price (+ addons).
 * Patches GPO selectors once and re-applies theme discount pricing when needed.
 */
(function () {
  'use strict';

  var STUB_SELECTOR = '[data-msl-gpo-price-stub]';
  var REAPPLY_DELAY_MS = 80;
  var GPO_POLL_INTERVAL_MS = 100;
  var GPO_POLL_MAX = 30;
  var BOOTSTRAP_DELAYS_MS = [0, 200, 600, 1500];

  var gpoPatched = false;
  var reapplyTimer = null;
  var gpoPollCount = 0;
  var bootstrapScheduled = false;

  function patchGpoThemeConfig() {
    if (gpoPatched) {
      return true;
    }

    var productConfig = window.GPOConfigs && window.GPOConfigs.theme && window.GPOConfigs.theme.product;
    if (!productConfig) {
      return false;
    }

    productConfig.unitPrice = STUB_SELECTOR;
    productConfig.compareAtPrice = STUB_SELECTOR;
    if (productConfig.price != null) {
      productConfig.price = STUB_SELECTOR;
    }
    productConfig._mslPriceGuardPatched = true;
    gpoPatched = true;
    return true;
  }

  function pollForGpoConfig() {
    if (patchGpoThemeConfig()) {
      scheduleReapply();
      return;
    }

    gpoPollCount += 1;
    if (gpoPollCount < GPO_POLL_MAX) {
      setTimeout(pollForGpoConfig, GPO_POLL_INTERVAL_MS);
    }
  }

  function formatThemeMoney(cents) {
    if (!window.themeVariables || !window.themeVariables.settings) {
      return String(Math.round(cents / 100));
    }

    var settings = window.themeVariables.settings;
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var match = format.match(placeholderRegex);
    if (!match) {
      return formatWithDelimiters(cents, 0);
    }

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 0);
        break;
    }

    return format.replace(placeholderRegex, value);
  }

  function setMoneyElement(parent, html) {
    var money = document.createElement('span');
    money.className = 'money';
    money.setAttribute('data-msl-no-strip', 'true');
    money.innerHTML = html;
    parent.appendChild(money);
    return money;
  }

  function expectedPriceKey(discounted, comparePrice) {
    return String(discounted) + ':' + String(comparePrice);
  }

  function applyThemeDiscountToPriceList(priceList, variantPriceCents) {
    if (!priceList || priceList.getAttribute('data-show-discounted') !== 'true' || variantPriceCents == null) {
      return false;
    }

    var discountFactor = parseFloat(priceList.getAttribute('data-discount-factor')) || 0.75;
    var discounted = Math.round(variantPriceCents * discountFactor);
    var comparePrice = variantPriceCents;
    var priceKey = expectedPriceKey(discounted, comparePrice);

    if (discounted >= comparePrice) {
      return false;
    }

    if (priceList.getAttribute('data-msl-prices') === priceKey) {
      return false;
    }

    var saleEl = priceList.querySelector('sale-price[data-show-discounted]');
    var compareEl = priceList.querySelector('compare-at-price[data-compare-with="sale_price"]');

    if (saleEl) {
      var saleSrOnly = saleEl.querySelector('.sr-only');
      saleEl.replaceChildren();
      if (saleSrOnly) {
        saleEl.appendChild(saleSrOnly);
      }
      setMoneyElement(saleEl, formatThemeMoney(discounted));
      saleEl.classList.add('text-on-sale');
    }

    if (compareEl) {
      var compareSrOnly = compareEl.querySelector('.sr-only');
      compareEl.replaceChildren();
      if (compareSrOnly) {
        compareEl.appendChild(compareSrOnly);
      }
      setMoneyElement(compareEl, formatThemeMoney(comparePrice));
      compareEl.hidden = false;
    }

    var discountBadge = compareEl && compareEl.nextElementSibling;
    if (discountBadge && discountBadge.textContent && discountBadge.textContent.indexOf('% OFF') !== -1) {
      var badgeSrOnly = discountBadge.querySelector('.sr-only');
      var pct = Math.round(100 - discountFactor * 100);
      discountBadge.replaceChildren();
      if (badgeSrOnly) {
        discountBadge.appendChild(badgeSrOnly);
      }
      discountBadge.appendChild(document.createTextNode('(' + pct + '% OFF)'));
      discountBadge.hidden = false;
    }

    priceList.setAttribute('data-msl-prices', priceKey);
    return true;
  }

  function getVariantPriceCents(form) {
    if (window._mslLastVariant && window._mslLastVariant.price != null) {
      return window._mslLastVariant.price;
    }

    if (window.GPOConfigs && window.GPOConfigs.product) {
      var variants = window.GPOConfigs.product.variants;
      var idInput = form && form.querySelector('[name="id"]');
      var id = idInput && idInput.value;

      if (variants && id) {
        var matched = variants.find(function (variant) {
          return String(variant.id) === String(id);
        });
        if (matched) {
          return matched.price;
        }
      }

      return window.GPOConfigs.product.price;
    }

    return null;
  }

  function reapplyAllPriceLists() {
    document.querySelectorAll('price-list[data-show-discounted="true"]').forEach(function (priceList) {
      var saleEl = priceList.querySelector('sale-price[form]');
      var formId = saleEl && saleEl.getAttribute('form');
      var form = formId && document.getElementById(formId);
      var price = getVariantPriceCents(form);

      applyThemeDiscountToPriceList(priceList, price);
    });
  }

  function scheduleReapply() {
    clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(reapplyAllPriceLists, REAPPLY_DELAY_MS);
  }

  function scheduleBootstrapReapplies() {
    if (bootstrapScheduled) {
      return;
    }

    bootstrapScheduled = true;
    BOOTSTRAP_DELAYS_MS.forEach(function (delay) {
      setTimeout(reapplyAllPriceLists, delay);
    });
  }

  document.addEventListener(
    'variant:change',
    function (event) {
      window._mslLastVariant = event.detail && event.detail.variant;
      document.querySelectorAll('price-list[data-show-discounted="true"]').forEach(function (priceList) {
        priceList.removeAttribute('data-msl-prices');
      });
      scheduleReapply();
    },
    true
  );

  function init() {
    patchGpoThemeConfig();
    scheduleBootstrapReapplies();
    pollForGpoConfig();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
